import { UntypedFormControl } from '@angular/forms';
import { ComponentRef, ViewContainerRef } from '@angular/core';
import { FieldValidation } from '../field-validation';
import {
  FieldValueInterface,
  FormCustomInput,
  FormInputComponent,
  ObjectType,
  RenderableFieldInterface,
} from '../../../tokens-and-interfaces';

export class CustomFieldHandler implements RenderableFieldInterface {
  formControl: UntypedFormControl;
  component: ComponentRef<FormInputComponent>;

  constructor(
    public customFormInput: FormCustomInput,
    public objectType: ObjectType,
    public fieldId: string,
    public label: string,
    public value: unknown,
    public readOnly = false,
  ) {
    this.formControl = new UntypedFormControl(value);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setValidation(validation: FieldValidation): void {
    return;
  }

  fieldValue(): FieldValueInterface {
    if (!this.component?.instance) {
      return {
        fieldId: this.fieldId,
      };
    }
    return this.component.instance.value;
  }

  hasModification(): boolean {
    if (!this.component?.instance) {
      return false;
    }
    return this.component.instance.hasModification;
  }

  render(viewContainerRef: ViewContainerRef): void {
    if (!this.customFormInput || !this.customFormInput.component) {
      return;
    }

    viewContainerRef.clear();
    this.component = viewContainerRef.createComponent<FormInputComponent>(this.customFormInput.component);
    this.component.instance.fieldId = this.fieldId;
    this.component.instance.control = this.formControl;
    this.component.instance.label = this.label;
    this.component.instance.readOnly = this.readOnly;
    this.component.instance.objectType = this.objectType;
  }

  // unused for custom inputs
  description: string;
  name: string;
  validation: FieldValidation;
}
